export const color = {
    white : '#FFFFFF',
    black : '#000000',
    primary : '#00FF00'
}